import Image from 'next/image';
import { useMemo } from 'react';

import useGetChainInfo from '@/hooks/useGetChainInfo';
import { getAddressScannerUrl, maskAddressValue } from '@/utils/format';

import { EventTriggerType, Trigger } from '../../domain';
import { TriggerExternalLinkDetail } from './components/TriggerExternalLinkDetail';
import { TriggerType } from './components/TriggerType';

interface Props {
  trigger: Trigger;
  triggerType: EventTriggerType;
}

export const SpectraLPTriggerDetails = ({ trigger, triggerType }: Props) => {
  const { getChainIconUrl } = useGetChainInfo();

  const tokenAddress = trigger.context?.token_address ?? '';
  const chainId = trigger.context?.chain_id;

  const scannerUrl = useMemo(() => {
    if (!tokenAddress || !chainId) return '';
    return getAddressScannerUrl('chainId', chainId, tokenAddress) || '';
  }, [tokenAddress, chainId]);

  const chainIconUrl = useMemo(() => {
    if (!chainId) return '';
    return getChainIconUrl(chainId) || '';
  }, [chainId, getChainIconUrl]);

  return (
    <div className="tw:flex tw:flex-row tw:gap-6">
      <TriggerType eventType={triggerType} />

      <TriggerExternalLinkDetail
        label="Token Address"
        value={
          <div className="tw:flex tw:flex-row tw:gap-1 tw:items-center">
            {chainIconUrl && <Image src={chainIconUrl} width={12} height={12} alt="chain" />}
            <span>{maskAddressValue(tokenAddress) ?? ''}</span>
          </div>
        }
        href={scannerUrl}
      />
    </div>
  );
};
